import Dropdown from 'common/drop-down/DropDown';
import { useRef, useState } from 'react';
import styles from './ProductVariantNameBox.module.scss';
import { Flex } from 'antd';
import { OrderIcon } from 'common/all-icons/custom-icons';
import clsx from 'clsx';
import { ConfigTenant } from 'configs/tenant.config';
import { useIsMobile } from 'hooks';

const ProductVariantDropdown = ({
  variants = [],
  darkTheme = false,
  children = <></>,
  trigger = ['hover'],
  placement = 'bottomLeft',
  attachToBody = false,
}) => {
  const [visible, setVisible] = useState(false);
  const isMobile = useIsMobile();
  const colorPrimaryDark = ConfigTenant.data.color.ant_variables.primary_color_dark;

  const wrapperRef = useRef(null);

  const effectiveTrigger = isMobile ? ['click'] : trigger;
  const effectivePlacement = isMobile ? 'bottom' : placement;

  const renderDropdownButton = () => {
    return children;
  };

  if (!variants?.length) return children;

  return (
    <div ref={wrapperRef} className={clsx(styles.dropdownWrapper, darkTheme ? styles.dark : '')}>
      <Dropdown
        placement={effectivePlacement}
        trigger={effectiveTrigger}
        onVisibleChange={(flag) => setVisible(flag)}
        DropDownButton={renderDropdownButton}
        visible={visible}
        getPopupContainer={attachToBody ? undefined : () => wrapperRef.current}
        overlayClassName={clsx(styles.dropdownOverlay, darkTheme && styles.dark)}
        arrow={{ pointAtCenter: true }}
        dropdownRender={() => (
          <Flex vertical gap={12} className={clsx(styles.dropdownContainer, darkTheme ? styles.dark : '')}>
            {variants.map((variant, index) => {
              const isInternal = variant?.product?.type?.slug === 'internal';
              const variantName = variant?.name || '';
              const productName = variant?.product?.name;

              return (
                <Flex gap={12} key={index} align="center">
                  <OrderIcon
                    style={{ flexShrink: 0, color: darkTheme ? colorPrimaryDark : 'var(--ant-color-primary)' }}
                  />

                  <Flex vertical>
                    {isInternal && <div className="body-12-semibold">{productName}</div>}

                    <div
                      style={{ color: isInternal ? (darkTheme ? '#BFBFBF' : 'var(--user-main-text)') : '' }}
                      className={isInternal ? 'body-11-medium' : 'body-12-semibold'}
                    >
                      {variantName}
                    </div>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        )}
      />
    </div>
  );
};

export default ProductVariantDropdown;
